import { AppUser } from 'global-shared/models/user-account.model';

// tslint:disable-next-line: no-namespace
export namespace AuthActions {
  export class Claims {
    static readonly type = '[AUTH] Set Claims';
    constructor(public payload: any) { }
  }
  export class Loading {
    static readonly type = '[AUTH] Set Loading';
    constructor(public payload: boolean) { }
  }
  export class Login {
    static readonly type = '[AUTH] Login';
    constructor(public payload: { email: string; password: string }) { }
  }

  export class Signin {
    static readonly type = '[AUTH] Signin';
  }

  export class Signout {
    static readonly type = '[AUTH] Signout';
  }

  export class Signup {
    static readonly type ='[AUTH] Signup';
    constructor(public payload: { email: string; password: string }) { }
  }

  export class User {
    static readonly type = '[AUTH] Set User';
    constructor(public payload: AppUser) { }
  }

  export class GetUser {
    static readonly type = '[AUTH] Get User';
  }

}
